import React from 'react';
import {
  FieldValues, useController, PathValue, Path,
} from 'react-hook-form';
import { CommonReactHookFormProps } from '../types';
import File, { FileProps, FileValueType } from '.';

export interface RHFFileProps<
    FormFields extends FieldValues,
  > extends CommonReactHookFormProps<FormFields>, FileProps {}

const RHFFile = function<FormFields extends FieldValues> (props: RHFFileProps<FormFields>) {
  const {
    name,
    supportTypes,
    label,
    isMandatory,
    minSize,
    maxSize,
    control,
    value,
    ...rest
  } = props;

  const {
    field,
    fieldState: { error },
  } = useController<FormFields>({
    name,
    control,
    rules: { required: true },
    defaultValue: value as PathValue<FormFields, Path<FormFields>> | undefined,
  });

  const { onChange } = field;

  const handleFileChange = (event: FileValueType) => {
    onChange(event);
  };

  return (
    <File
      label={label}
      value={field.value}
      supportTypes={supportTypes}
      isMandatory={isMandatory}
      minSize={minSize}
      maxSize={maxSize}
      onChange={handleFileChange}
      error={error}
      {...rest}
    />
  );
};

export default RHFFile;
